import { mergeStates } from '../../iwProvider/StoreHelper';
import { getDocumentTypes } from '../modals/uploadDocumentsModal/UploadDocumentsModalHelper';
import {
    CONFIRM_UNLINKING_ACCOUNT,
    LEAVE_TRADING_DATA,
    SET_TRADING_DATA_LINKED_ACCOUNTS,
    SET_UNLINKING_ACCOUNT,
    TRADING_DATA_DATA,
    TRADING_DATA_DATA_LOADING,
    TRADING_DATA_UPLOADED_DOCOUMENTS,
    UNLINKING_ACCOUNT_FAIL,
    UNLINKING_ACCOUNT_SUCCESS
} from './TradingData.actions';
import {
    deserialiseLinkedOpenBankingAccounts,
    groupByDocumentType
} from './TradingDataHelper';

const initialState = {
    ready: false,
    linkedAccounts: []
};

// eslint-disable-next-line import/no-default-export
export default function (state = mergeStates(initialState), action = {}) {
    switch (action.type) {
        case TRADING_DATA_DATA_LOADING:
            return mergeStates(state, {
                ready: false
            });

        case TRADING_DATA_DATA:
            return mergeStates(state, {
                ready: true,
                documentTypes: getDocumentTypes(action.customer_state),
                uploaded_documents: groupByDocumentType(action.document_upload),
                linkedAccounts: deserialiseLinkedOpenBankingAccounts(
                    action.online_account,
                    action.allOpenBankingBanks
                )
            });

        case SET_TRADING_DATA_LINKED_ACCOUNTS:
            return {
                ...state,
                linkedAccounts: deserialiseLinkedOpenBankingAccounts(
                    action.online_account,
                    action.allOpenBankingBanks
                )
            };
        case TRADING_DATA_UPLOADED_DOCOUMENTS:
            return mergeStates(state, {
                uploaded_documents: groupByDocumentType(action.document_upload)
            });

        case SET_UNLINKING_ACCOUNT:
            return mergeStates(state, {
                unlinkingLinkedAccountName: action.onlineAccountName,
                unlinkingLinkedAccountStatus: null
            });

        case CONFIRM_UNLINKING_ACCOUNT:
            return mergeStates(state, {
                accountUnlinkingInProgress: true
            });

        case LEAVE_TRADING_DATA:
            return mergeStates(initialState);

        case UNLINKING_ACCOUNT_SUCCESS:
            return mergeStates(state, {
                unlinkingLinkedAccountStatus: 'success',
                accountUnlinkingInProgress: false
            });

        case UNLINKING_ACCOUNT_FAIL:
            return mergeStates(state, {
                unlinkingLinkedAccountStatus: 'error',
                accountUnlinkingInProgress: false
            });

        default:
            return state;
    }
}
